import { Injectable } from '@angular/core';
import olMap from 'ol/Map';
import { MapService } from 'src/app/services/map.service';
import Overlay from 'ol/Overlay';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {getArea, getLength} from 'ol/sphere';
import {unByKey} from 'ol/Observable';
import { Draw } from 'ol/interaction';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import * as olProj from 'ol/proj';
import { SearchItem } from 'src/app/models/searchItem';
import { SearchService } from 'src/app/services/search.service';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { DisplayCalculationInfo } from 'src/app/models/DisplayCalculationInfo';
import { EventListenersOnMap } from 'src/app/utils/eventListenersOnMap';


@Injectable({
  providedIn: 'root'
})

export class DistanceAzimuthService {

  active: boolean = false;
  map: olMap;

  sketch;
  continueLineMsg = 'Click to continue drawing the line';
  helpTooltipElement;
  helpTooltip;
  draw;
  measureTooltip;
  measureTooltipElement;
  listener;
  pointerMoveListener;
  distanceResult;
  azimuthResult;

  static readonly EVENT_ON_MAP_LABEL: string = 'Distance Azimuth';

  raster = new TileLayer({
    source: new OSM(),
  });

  source = new VectorSource();

  style = new Style({
    stroke: new Stroke({
      color: 'rgba(15,154,213)',
      width: 2,

    })
  })

  vector = new VectorLayer({
    source: this.source,
    style: this.style
  });

  constructor(private mapService:MapService,
     private configurationService: ConfigurationService,
     private vicentyTool : VicentyToolControlService,
     private searchService : SearchService,
     private rcsControl: CoordenateService,
     ) {

    this.map = mapService.getMap('map');
    this.map.addLayer(this.vector);


  }

  activeDistanceAzimuth() {

    this.active = !this.active;
    EventListenersOnMap.addEventListener(DistanceAzimuthService.EVENT_ON_MAP_LABEL, 'pointermove', function (evt) {
      if (evt.dragging) {
        return;
    }

      let helpMsg = 'Click to start drawing';

      if (this.sketch) {
        const geom = this.sketch.getGeometry();
        helpMsg = this.continueLineMsg;
      }

      this.helpTooltipElement.innerHTML = helpMsg;
      this.helpTooltip.setPosition(evt.coordinate);
      this.helpTooltipElement.classList.remove('hidden');
    }.bind(this), true);

    this.createDraw();
    this.createMeasureTooltip();
    this.createHelpTooltip();
    this.map.addInteraction(this.draw);

  }

  createHelpTooltip() {

    if (this.helpTooltipElement) {
      this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
    }
    this.helpTooltipElement = document.createElement('div');
    this.helpTooltipElement.setAttribute('id', 'helpToolTip');
    this.helpTooltipElement.className = 'ol-tooltip hidden';
    this.helpTooltip = new Overlay({
      element: this.helpTooltipElement,
      offset: [15, 0],
    });
    this.map.addOverlay(this.helpTooltip);
    // this.mouseOutListener = this.map.getViewport().addEventListener('mouseout', function () {
    //   this.helpTooltipElement.classList.add('hidden');
    // }.bind(this));

  }

  formatLength(line) {

    let coordinate1 = olProj.toLonLat([line.getFirstCoordinate()[0], line.getFirstCoordinate()[1]],this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
    let coordinate2 = olProj.toLonLat([line.getLastCoordinate()[0], line.getLastCoordinate()[1]],this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");

    this.azimuthResult = VicentyToolControlService.calculateAzimuth(coordinate1[1], coordinate1[0], coordinate2[1], coordinate2[0]);

    const length = getLength(line,{projection: this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857"});
    if(this.configurationService.currentConfiguration.display.horizontalUnits == "NM"){
      let output = Math.round((length * 0.000539956803) * 1000000) / 1000000;
      return parseFloat(output.toString()).toFixed(2) + ' [NM]<br>' + parseFloat(this.azimuthResult).toFixed(2) + ' [deg]';
    }
    else{
        return parseFloat(length.toString()).toFixed(2) + ' [m]<br>' + parseFloat(this.azimuthResult).toFixed(2) + ' [deg]';

    }

    // .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  };

  createDraw() {
    this.draw = new Draw({
      source: this.source,
      type: "LineString",
      style: new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.5)',
          lineDash: [10, 10],
          width: 2,
        }),
        image: new CircleStyle({
          radius: 5,
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.7)',
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
        }),
      }),
    });

    this.draw.on('drawstart', function (evt) {
      // set sketch
      this.sketch = evt.feature;
      let tooltipCoord = evt.coordinate;

      this.listener = this.sketch.getGeometry().on('change', function (evt) {
        const geom = evt.target;
        let output = this.formatLength(geom);
        tooltipCoord = geom.getLastCoordinate();
        this.measureTooltipElement.innerHTML = output;
        this.measureTooltip.setPosition(tooltipCoord);
        //document.getElementsByClassName("distance-azimuth__container")[0].innerHTML = "Distance: " + output  + "<br>" + "Azimuth: " + parseFloat(this.azimuthResult).toFixed(2) + ' [deg]';
      }.bind(this));

    }.bind(this));

    this.draw.on('drawend', function () {
      this.measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
      this.measureTooltip.setOffset([0, -7]);
      // unset sketch
      this.sketch = null;
      // unset tooltip so that a new one can be created
      this.measureTooltipElement = null;
      this.createMeasureTooltip();
      unByKey(this.listener);

    }.bind(this));

  }

  createMeasureTooltip() {

    if (this.measureTooltipElement) {
      this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
    }
    this.measureTooltipElement = document.createElement('div');
    this.measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
    this.measureTooltip = new Overlay({
      element:this.measureTooltipElement,
      offset: [0, -28],
      stopEvent: false,
      insertFirst: false,
    });
    this.map.addOverlay(this.measureTooltip);
  }

  clearMeasures() {

    this.clearListeners();
    this.vector.getSource().clear();

    this.sketch = null;
    this.createMeasureTooltip();
    unByKey(this.listener);

  }

  clearListeners() {
    this.map.removeInteraction(this.draw);
    if(this.helpTooltipElement != null) {
      document.getElementById('helpToolTip').remove();
      this.helpTooltipElement = null;
    }
  }

  removeElementsByClass(className){
    const elements = document.getElementsByClassName(className);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
    this.active = false;
  }
  reproject(sourceProjection){
    this.source?.getFeatures().forEach(feature=>
        feature.getGeometry().transform(sourceProjection,this.map.getView().getProjection().getCode())
      );
  }
}
